import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { CoordinationRequest } from '../../requests/billing/coordination.request';
import { CoordinationResponse } from '../../responses/billing/coordination.response';
import { ListCoordinationResponse } from '../../responses/billing/list-coordination.response';

@Injectable({
  providedIn: 'root'
})
export class CoordinationService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  Get(idCoordination: number): Observable<CoordinationResponse>{
    let uri = `Coordination/idCoordination/${idCoordination}`;

    return this.httpClient.get<CoordinationResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBilling) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  GetAll(searchText: string): Observable<ListCoordinationResponse>{
    let uri = `Coordination/getAll`;
    
    if(searchText)
      uri = uri + `?searchText=${searchText}`;

    return this.httpClient.get<ListCoordinationResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBilling) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  Create(request: CoordinationRequest): Observable<ReturnStruct>{
    let uri = `Coordination`;
  
    return this.httpClient.post<CoordinationResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBilling) + uri, request, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  Update(idCoordination: number, request: CoordinationRequest): Observable<ReturnStruct>{
    let uri = `Coordination/idCoordination/${idCoordination}`;
  
    return this.httpClient.put<CoordinationResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBilling) + uri, request, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  Delete(idCoordination: number): Observable<ReturnStruct>{
    let uri = `Coordination/idCoordination/${idCoordination}`;

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBilling) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
